import { render } from "./SingleTalentView.vue?vue&type=template&id=9978b9a6&scoped=true"
import script from "./SingleTalentView.vue?vue&type=script&lang=js"
export * from "./SingleTalentView.vue?vue&type=script&lang=js"

import "./SingleTalentView.vue?vue&type=style&index=0&id=9978b9a6&lang=css&scoped=true"

import exportComponent from "/var/www/mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9978b9a6"]])

export default __exports__